export default function Shope({
  color = '#878F9B',
  width = '20',
  height = '20',
}: {
  color?: string;
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.88123 7.01172V9.81797C1.88123 12.6242 3.00623 13.7492 5.81248 13.7492H9.18123C11.9875 13.7492 13.1125 12.6242 13.1125 9.81797V7.01172'
        stroke={color}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M7.50005 7.5C8.6438 7.5 9.48755 6.56875 9.37505 5.425L8.96255 1.25H6.0438L5.62505 5.425C5.51255 6.56875 6.3563 7.5 7.50005 7.5Z'
        stroke={color}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M11.4437 7.5C12.7062 7.5 13.6313 6.475 13.5063 5.21875L13.3312 3.5C13.1062 1.875 12.4813 1.25 10.8438 1.25H8.9375L9.375 5.63125C9.48125 6.6625 10.4125 7.5 11.4437 7.5Z'
        stroke={color}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M3.52499 7.5C4.55624 7.5 5.48749 6.6625 5.58749 5.63125L5.72499 4.25L6.02499 1.25H4.11874C2.48124 1.25 1.85624 1.875 1.63124 3.5L1.46249 5.21875C1.33749 6.475 2.26249 7.5 3.52499 7.5Z'
        stroke={color}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M7.5 10.625C6.45625 10.625 5.9375 11.1438 5.9375 12.1875V13.75H9.0625V12.1875C9.0625 11.1438 8.54375 10.625 7.5 10.625Z'
        stroke={color}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
